// Mock data for Banner of Grace Ministry website

export const programs = [
  {
    id: "1",
    title: "Prayer Meetings",
    description: "Join us for powerful prayer sessions every Tuesday and Thursday evening. Experience the transformative power of collective prayer.",
    icon: "hand-heart",
    category: "Spiritual"
  },
  {
    id: "2",
    title: "Bible Study Groups",
    description: "Deep dive into God's Word with our weekly Bible study sessions. Learn, grow, and fellowship with other believers.",
    icon: "book-open",
    category: "Education"
  },
  {
    id: "3",
    title: "Youth Ministry",
    description: "Empowering the next generation with Christ-centered programs, mentorship, and activities designed for young believers.",
    icon: "users",
    category: "Youth"
  },
  {
    id: "4",
    title: "Community Outreach",
    description: "Reaching out to our community with the love of Christ through food drives, healthcare camps, and social services.",
    icon: "heart-handshake",
    category: "Service"
  },
  {
    id: "5",
    title: "Sunday Worship Service",
    description: "Join us every Sunday for spirit-filled worship, powerful preaching, and fellowship. Service starts at 9:00 AM.",
    icon: "church",
    category: "Worship"
  },
  {
    id: "6",
    title: "Charity Programs",
    description: "Supporting the less privileged through various charity initiatives including education sponsorship and widow support.",
    icon: "hand-holding-heart",
    category: "Charity"
  },
  {
    id: "7",
    title: "Evangelical Missions",
    description: "Spreading the Gospel to unreached communities through organized mission trips and evangelism programs.",
    icon: "globe",
    category: "Mission"
  },
  {
    id: "8",
    title: "Women's Fellowship",
    description: "A supportive community for women to grow in faith, share experiences, and encourage one another in Christ.",
    icon: "users-round",
    category: "Fellowship"
  },
  {
    id: "9",
    title: "Children's Ministry",
    description: "Nurturing young hearts with Bible stories, crafts, and activities. Teaching children about God's love in a fun environment.",
    icon: "users",
    category: "Children"
  },
  {
    id: "10",
    title: "Music & Choir Ministry",
    description: "Worship through music! Join our choir and praise team to lead congregational worship and special music performances.",
    icon: "music",
    category: "Worship"
  },
  {
    id: "11",
    title: "Marriage & Family Counseling",
    description: "Biblical counseling and support for couples and families. Strengthening relationships through Christ-centered guidance.",
    icon: "heart",
    category: "Counseling"
  },
  {
    id: "12",
    title: "Hospital Visitation",
    description: "Bringing hope and prayers to the sick and hospitalized. Showing God's love through compassionate care and support.",
    icon: "heart-pulse",
    category: "Service"
  },
  {
    id: "13",
    title: "Prison Ministry",
    description: "Reaching out to inmates with the Gospel message, offering hope, redemption, and spiritual guidance behind bars.",
    icon: "hand-helping-heart",
    category: "Mission"
  },
  {
    id: "14",
    title: "Feeding Program",
    description: "Weekly food distribution to needy families and homeless individuals. Demonstrating Christ's love through practical care.",
    icon: "utensils",
    category: "Service"
  },
  {
    id: "15",
    title: "Leadership Training",
    description: "Equipping future church leaders with biblical knowledge, ministry skills, and spiritual formation for effective service.",
    icon: "graduation-cap",
    category: "Education"
  },
  {
    id: "16",
    title: "Widows & Orphans Support",
    description: "Providing financial, emotional, and spiritual support to widows and orphans in our community.",
    icon: "hand-heart",
    category: "Charity"
  }
];

export const testimonials = [
  {
    id: "1",
    name: "Sister Grace Nwosu",
    content: "This ministry transformed my life completely. The love and support I received here helped me overcome my darkest moments. Glory to God!",
    role: "Member since 2019",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop"
  },
  {
    id: "2",
    name: "Brother Emmanuel Okafor",
    content: "The youth program here gave me purpose and direction. I found my calling through the mentorship and teaching I received.",
    role: "Youth Leader",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop"
  },
  {
    id: "3",
    name: "Pastor John Adeyemi",
    content: "Partnering with Banner of Grace Ministry has been a blessing. Their commitment to spreading the Gospel is truly inspiring.",
    role: "Partner Church",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop"
  },
  {
    id: "4",
    name: "Sister Mary Ugochukwu",
    content: "The community outreach program touched my heart. Seeing lives changed through simple acts of kindness is what Christianity is about.",
    role: "Volunteer",
    avatar: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&h=200&fit=crop"
  },
  {
    id: "5",
    name: "Deacon Samuel Obi",
    content: "Serving in this ministry for over 10 years has been the greatest blessing. The fellowship and spiritual growth here are unmatched.",
    role: "Deacon & Elder",
    avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&h=200&fit=crop"
  },
  {
    id: "6",
    name: "Sister Blessing Chioma",
    content: "The women's fellowship changed my perspective on life. I found sisters who pray with me, encourage me, and walk with me in faith.",
    role: "Women's Group Leader",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop"
  }
];

export const events = [
  {
    id: "1",
    title: "Annual Revival Conference",
    description: "Three days of powerful worship, teaching, and spiritual renewal. Join us for this transformative experience.",
    date: "July 18-20, 2026",
    location: "Church Main Auditorium, Enugu"
  },
  {
    id: "2",
    title: "Community Food Drive",
    description: "Help us feed 500 families in need. Volunteer or donate to make a difference in our community.",
    date: "August 2, 2026",
    location: "Waec Junction, Enugu"
  },
  {
    id: "3",
    title: "Mission Trip to Northern Nigeria",
    description: "Join our evangelical mission to reach unreached communities with the Gospel message.",
    date: "August 10-17, 2026",
    location: "Northern Nigeria"
  },
  {
    id: "4",
    title: "Youth Leadership Summit",
    description: "Empowering young leaders with skills, knowledge, and spiritual guidance for impactful ministry.",
    date: "September 7-8, 2026",
    location: "Youth Center, Independence Layout"
  },
  {
    id: "5",
    title: "Women's Conference",
    description: "A special gathering for women to be refreshed, empowered, and encouraged in their walk with God.",
    date: "October 25, 2026",
    location: "Church Main Auditorium, Enugu"
  },
  {
    id: "6",
    title: "Children's Christmas Party",
    description: "Fun-filled celebration for children with games, gifts, and the Christmas story. Bring your kids!",
    date: "December 20, 2026",
    location: "Youth Center, Independence Layout"
  },
  {
    id: "7",
    title: "Christmas Carol Service",
    description: "Join us for a special Christmas celebration with caroling, worship, and the sharing of God's Word.",
    date: "December 24, 2026",
    location: "Church Main Auditorium, Enugu"
  },
  {
    id: "8",
    title: "New Year Thanksgiving Service",
    description: "Start the new year with thanksgiving and praise. Special thanksgiving service with prayers and declarations.",
    date: "January 1, 2027",
    location: "Church Main Auditorium, Enugu"
  }
];
